import React from "react";
import { useLang } from "../i18n/LanguageContext";
import { LANGUAGES } from "../i18n/translations";
import { ChevronDown, Check } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from "./ui/dropdown-menu";

export const LanguageSwitcher = ({ variant = "dark" }) => {
  const { lang, setLang } = useLang();
  const current = LANGUAGES.find((l) => l.code === lang) || LANGUAGES[0];
  const triggerCls =
    variant === "dark"
      ? "text-white/80 hover:text-white border-white/20 hover:border-white/40"
      : "text-[#0C2230]/80 hover:text-[#0C2230] border-[#0C2230]/15 hover:border-[#0C2230]/30";

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        data-testid="language-switcher-trigger"
        className={`inline-flex items-center gap-1.5 rounded-full border px-3 py-1.5 text-xs font-medium tracking-wide transition-colors ${triggerCls}`}
      >
        <span className="font-semibold">{current.label}</span>
        <ChevronDown className="h-3.5 w-3.5 opacity-70" />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[140px]">
        {LANGUAGES.map((l) => (
          <DropdownMenuItem
            key={l.code}
            data-testid={`language-option-${l.code}`}
            onClick={() => setLang(l.code)}
            className="flex items-center justify-between gap-3 cursor-pointer"
          >
            <span>{l.name}</span>
            {l.code === lang && <Check className="h-4 w-4 text-[#0E9A57]" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default LanguageSwitcher;
